module.exports = __webpack_public_path__ + "img/delete-icon.21a30c5a.svg";